export const clearStore = "NOTIFICATION_CLEAR_STORE";


export const listLoadStart = 'NOTIFICATION_LIST_LOAD_START';
export const listLoadSuccess = 'NOTIFICATION_LIST_LOAD_SUCCESS';
export const listLoadFail = 'NOTIFICATION_LIST_LOAD_FAIL';

export const itemDeleteStart = 'NOTIFICATION_DELETE_START';
export const itemDeleteSuccess = 'NOTIFICATION_DELETE_SUCCESS';
export const itemDeleteFail = 'NOTIFICATION_DELETE_FAIL';